import * as React from 'react';
import * as qs from 'query-string';
import * as moment from 'moment';
import * as _ from 'lodash';
import { Button, FormControl, Row, Label } from 'react-bootstrap';
import { FilterWrapper } from './styles';
import MediaQuery from 'react-responsive';
import { IRecipientRequest } from '@nkr/store/index';
import MaskedInput from "react-maskedinput";
import { IListItem } from '@nkr/models/index';
import { IFilterData } from './filter-data';

interface IProps {
    centerId: number,
    centerList: IListItem[],
    filterData: IFilterData,
    onUpdateFilter: (data: IFilterData) => void,
    onSearch: () => void,
}

const Filter = (props: IProps) => {
    const handleFieldChange = (e: React.FormEvent<FormControl & HTMLSelectElement & HTMLInputElement>) => {
        let id = e.currentTarget.id;
        let value = e.currentTarget.value;
        let filterData = _.cloneDeep(props.filterData);

        if (id == 'centerId') {
            filterData.centerId = parseInt(value);
        }

        if (id == 'show') {
            filterData.show = parseInt(value);
        }

        if (id == 'status') {
            filterData.status = parseInt(value);
        }

        if (id == 'alias') {
            filterData.alias = value;
        }

        if (id == 'phiEmail') {
            filterData.phiEmail = value;
        }

        if (id == 'dob') {
            filterData.dob = value;
        }

        props.onUpdateFilter(filterData);
    };

    const handleSearch = () => {
        props.onSearch();
    };

    const handleKeyDown = (event: React.KeyboardEvent<FormControl & HTMLInputElement>): void => {
        if (event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            handleSearch();
        }
    };

    return (
        <>
            <FilterWrapper bsSize='sm'>
                <h4 style={{ marginTop: 0, marginBottom: 15 }}>SEARCH FILTERS</h4>

                <div style={{ display: 'flex', alignItems: 'center', marginLeft: 20, marginBottom: 20 }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginRight: 20 }}>
                        <div className='text-right' style={{ marginRight: 5 }}><strong>Center:</strong></div>
                        <div>
                            <FormControl
                                componentClass='select'
                                id='centerId'
                                value={props.filterData.centerId}
                                onChange={handleFieldChange}
                                style={{ width: '100%' }}
                            >
                                <option value={0}>- All -</option>
                                {props.centerList.map(center =>
                                    <option key={'ctr-' + center.id} value={center.id}>{center.description}</option>
                                )}
                            </FormControl>
                        </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', marginRight: 20 }}>
                        <div className='text-right' style={{ marginRight: 5 }}><strong>SHOW:</strong></div>
                        <div>
                            <FormControl
                                componentClass='select'
                                id='show'
                                value={props.filterData.show}
                                onChange={handleFieldChange}
                                style={{ width: '100%' }}
                            >
                                <option value={0}>All</option>
                                <option value={1}>Transplanted</option>
                                <option value={2} >Non-Transplanted</option>
                            </FormControl>
                        </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', marginRight: 20 }}>
                        <div className='text-right' style={{ marginRight: 5 }}><strong>STATUS:</strong></div>
                        <div>
                            <FormControl
                                componentClass='select'
                                id='status'
                                value={props.filterData.status}
                                onChange={handleFieldChange}
                                style={{ width: '100%' }}
                            >
                                <option value={0}>All</option>
                                <option value={3}>Exportable</option>
                                <option value={4}>Not Exportable</option>
                                <option value={5}>Deleted</option>
                            </FormControl>
                        </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', marginRight: 20 }}>
                        <div className='text-right' style={{ marginRight: 5 }}><strong>ID/Alias:</strong></div>
                        <div>
                            <FormControl
                                id='alias'
                                style={{ width: 200 }}
                                value={props.filterData.alias}
                                onKeyDown={handleKeyDown}
                                onChange={handleFieldChange}
                            />
                        </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', marginRight: 20 }}>
                        <div className='text-right' style={{ marginRight: 5 }}><strong>Email:</strong></div>
                        <div>
                            <FormControl
                                id='phiEmail'
                                style={{ width: 350 }}
                                value={props.filterData.phiEmail}
                                onKeyDown={handleKeyDown}
                                onChange={handleFieldChange}
                            />
                        </div>
                    </div>


                    <div style={{ display: 'flex', alignItems: 'center', marginRight: 20 }}>
                        <div className='text-right' style={{ marginRight: 5 }}><strong>DOB:</strong></div>
                        <div>
                            <MaskedInput
                                id='dob'
                                className='form-control'
                                style={{ width: 200 }}
                                mask={'11/11/1111'}
                                value={moment(props.filterData.dob).format('MM/DD/YYYY')}
                                onChange={handleFieldChange}
                            />
                        </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', float: 'right' }}>
                        <MediaQuery minDeviceWidth={1878}>
                            <div style={{ width: 150, marginLeft: 100 }}>
                                <Button className='btn-block' bsStyle="primary" onClick={handleSearch}>Search</Button>
                            </div>
                        </MediaQuery>

                        <MediaQuery maxDeviceWidth={1877}>
                            <div style={{ width: 150, marginLeft: 100 }}>
                                <Button className='btn-block btn-sm' bsStyle="primary" onClick={handleSearch}>Search</Button>
                            </div>
                        </MediaQuery>
                    </div>
                </div>

                <Row>
                    <div className='col-xs-12 col-sm-6'>
                        <Label bsStyle='warning' style={{ marginLeft: 20, fontSize: '90%' }}>
                            NOTE: Some settings conflict with each other. If you don't get any results, change less important options to 'All'
                        </Label>
                    </div>
                    <div className='col-xs-12 col-sm-6'>
                        {props.filterData.alias == '' && props.filterData.dob == '' && props.filterData.centerId == 0 && (
                            <Label bsStyle='info' style={{ marginLeft: 20, fontSize: '90%' }}>
                                Since no filters are specified the first 400 recipient records will be shown...
                            </Label>
                        )}
                    </div>
                </Row>
            </FilterWrapper>
        </>
    );
}

export default Filter;